const MID = process.env.REACT_APP_GA_MEASUREMENT_ID;

const gtag = (...args) => {
  if (typeof window === 'undefined' || !window.gtag || !MID) return;
  window.gtag(...args);
};

export const pageView = (path) => {
  gtag('config', MID, { page_path: path });
};

export const trackEvent = (name, params = {}) => {
  gtag('event', name, params);
};

// ── Typed events ──────────────────────────────────────────────────────────────

export const trackRomiStarted = () =>
  trackEvent('romi_score_started');

export const trackRomiCompleted = (totalScore, scoreLabel) =>
  trackEvent('romi_score_completed', { score_value: totalScore, score_tier: scoreLabel });

export const trackCtaClick = (location) =>
  trackEvent('cta_click', { cta_location: location });

export const trackBlogPostViewed = (slug, title, category) =>
  trackEvent('blog_post_viewed', { post_slug: slug, post_title: title, post_category: category });
